/** Guidance stays in form flow; preview marks are noninteractive and never printed. */
export const GUIDE_STYLES = `
.pz-guide { --pzg-aim: 28deg; --pzg-tilt: 0deg;
  display: grid; grid-template-columns: minmax(0, 1fr) 44px 44px; gap: 4px;
  align-items: center; min-width: 0; max-width: 100%; padding: 4px 6px;
  border: 1px solid #e6e6ec; border-radius: 12px; background: #f8f8fc;
  color: #1b1b22; text-align: start;
  font: 13px/1.45 var(--pz-font, "Inter", "Segoe UI", system-ui, sans-serif); }
.pz-guide [hidden] { display: none !important; }
.pz-guide-avatar, .pz-guide-dismiss, .pz-guide-mini {
  min-width: 44px; min-height: 44px; padding: 6px; margin: 0; border: 0;
  background: transparent; color: inherit; font: inherit; cursor: pointer; border-radius: 8px; }
.pz-guide-avatar { grid-column: 2; grid-row: 1; width: 44px; height: 44px; line-height: 0; }
.pz-guide-dismiss { grid-column: 3; grid-row: 1; font-size: 22px; }
.pz-guide.is-left { grid-template-columns: 44px minmax(0, 1fr) 44px; }
.pz-guide.is-left .pz-guide-avatar { grid-column: 1; }
.pz-guide.is-left .pz-guide-bubble { grid-column: 2; }
.pz-guide button:focus-visible { outline: 2px solid var(--pz-accent, #5145cd); outline-offset: 2px; }
.pz-guide button:hover { background-color: #efeff6; }
.pz-guide-figure, .pz-guide-figure svg { display: block; width: 100%; height: 100%; }
.pz-guide-figure svg { overflow: visible; }
.pz-guide-bubble { grid-column: 1; grid-row: 1; min-width: 0; padding: 4px;
  overflow-wrap: anywhere; text-align: start; }
.pz-guide-bubble.is-fading { opacity: .5; }
.pz-guide-help { grid-column: 1 / -1; display: grid; gap: 9px;
  min-width: 0; padding: 10px 6px; border-top: 1px solid #e6e6ec; text-align: start; }
/* The avatar's parts. Pivots are viewBox units; transform-box stays unset. */
.pzg-bear { transform-origin: 60px 112px; animation: pzg-breathe 3.4s ease-in-out infinite; }
.pzg-head { transform-origin: 60px 80px; transform: rotate(var(--pzg-tilt)); transition: transform .35s ease; }
.pzg-eyes { transform-origin: 60px 48px; animation: pzg-blink 4.8s ease-in-out infinite; }
.pzg-arm { transform-origin: 84px 88px; transform: rotate(var(--pzg-aim)); transition: transform .4s cubic-bezier(.2,.8,.2,1); }
.pzg-mouth-big { opacity: 0; transition: opacity .2s; }
.pz-guide.is-happy .pzg-mouth-big { opacity: 1; }
.pz-guide.is-happy .pzg-mouth { opacity: 0; }
.pz-guide.is-happy .pzg-bear { animation: pzg-bounce .55s ease-out 2; }
.pz-guide.is-wave .pzg-arm { animation: pzg-wave 1.3s ease-in-out 1; }
.pz-guide.is-busy .pzg-head { animation: pzg-think 1.6s ease-in-out infinite; }
/* Talking is a small nod — enough to read as "this one is speaking to me",
   not enough to pull the eye off the field the shopper is filling in. */
.pz-guide.is-talk .pzg-head { animation: pzg-talk 1.1s ease-in-out 2; }
.pz-guide.is-point .pzg-arm { transition-duration: .3s; }
@keyframes pzg-breathe { 50% { transform: translateY(-1.4px) scale(1.012); } }
@keyframes pzg-blink { 0%, 90%, 100% { transform: scaleY(1); } 94% { transform: scaleY(.08); } }
@keyframes pzg-bounce { 35% { transform: translateY(-7px); } 70% { transform: translateY(0) scale(1.03, .97); } }
@keyframes pzg-wave { 0%, 100% { transform: rotate(-70deg); } 25% { transform: rotate(-40deg); } 50% { transform: rotate(-75deg); } 75% { transform: rotate(-45deg); } }
@keyframes pzg-think { 50% { transform: rotate(-5deg) translateY(1px); } }
@keyframes pzg-talk { 30% { transform: rotate(calc(var(--pzg-tilt) + 3deg)); } 65% { transform: rotate(calc(var(--pzg-tilt) - 2deg)); } }


.pz-guide-help-head { display: flex; align-items: center; gap: 8px; }
.pz-guide-help-head .pz-guide-figure { flex: 0 0 auto; width: 28px; height: 28px; }
/* The little head is a portrait, not a pointer: it never mirrors or aims. */
.pz-guide-help-head .pz-guide-figure svg { --pzg-aim: 28deg; --pzg-tilt: 0deg; transform: none; }
.pz-guide-help-name { flex: 1; min-width: 0; font-weight: 650; font-size: 14px; }
.pz-guide-help-close { flex: 0 0 auto; display: grid; place-items: center; width: 28px; height: 28px;
  padding: 0; cursor: pointer; font-size: 13px; line-height: 1; color: #71717d; background: transparent;
  border: 0; border-radius: 99px; }
.pz-guide-help-close:hover { background: #f1f1f6; color: #1b1b22; }
.pz-guide-help-title { font-weight: 650; font-size: 13.5px; overflow-wrap: anywhere; }
.pz-guide-help-text { margin: 0; overflow-wrap: anywhere; }
.pz-guide-help-rules, .pz-guide-help-tips { margin: 0; padding-inline-start: 17px; display: grid; gap: 3px;
  font-size: 12.5px; color: #55555f; }
.pz-guide-help-rules li::marker { color: var(--pz-accent, #5145cd); }
.pz-guide-help-note { margin: 0; padding: 8px 10px; border-radius: 9px; background: #f5f5fa;
  font-size: 12.5px; color: #55555f; overflow-wrap: anywhere; }
.pz-guide-help-actions { display: flex; gap: 8px; }
.pz-guide-help-actions .pz-btn-ghost { padding: 8px 14px; font-size: 13px; }
.pz-guide-help-foot { display: grid; gap: 3px; padding-top: 8px; border-top: 1px solid #efeff4; }
.pz-guide-switch { position: relative; display: flex; align-items: center; gap: 9px; width: 100%;
  padding: 4px 0; cursor: pointer; font: inherit; font-weight: 550; color: #45454f; text-align: left;
  background: none; border: 0; }
.pz-guide-switch::before { content: ""; flex: 0 0 auto; width: 34px; height: 20px; border-radius: 99px;
  background: #d3d3dd; transition: background .15s ease; }
.pz-guide-switch::after { content: ""; position: absolute; left: 3px; top: 50%; width: 14px; height: 14px;
  margin-top: -7px; border-radius: 99px; background: #fff; box-shadow: 0 1px 3px rgba(20,20,40,.3);
  transition: transform .15s ease; }
.pz-guide-switch[aria-checked="true"]::before { background: var(--pz-accent, #5145cd); }
.pz-guide-switch[aria-checked="true"]::after { transform: translateX(14px); }
.pz-guide-switch-hint { margin: 0; font-size: 12px; color: #8a8a95; }


.pz-guide .pz-guide-help-close { width: 44px; height: 44px; }
.pz-guide .pz-guide-switch { min-height: 44px; }
.pz-guide-help-actions .pz-btn-ghost { min-height: 44px; }
.pz-guide-mini { display: none; grid-column: 1 / -1; text-align: start; }
.pz-guide.is-off { display: block; padding: 0; border: 0; background: transparent; }
.pz-guide.is-off .pz-guide-mini { display: block; }
.pz-guide.is-off .pz-guide-avatar, .pz-guide.is-off .pz-guide-dismiss,
.pz-guide.is-off .pz-guide-bubble, .pz-guide.is-off .pz-guide-help { display: none; }
/* Inset stroke preserves the exact layer bounds, including very small text.
   No opaque fill, captions or click targets over the product. */
.pz-guide-spot { position: absolute; z-index: 4; pointer-events: none; box-sizing: border-box;
  outline: 1.5px solid var(--pz-accent, #5145cd); outline-offset: -1.5px; border-radius: 3px; background: transparent;
  animation: pz-guide-pulse 1.4s ease-out 2; }
@keyframes pz-guide-pulse { 50% { outline-color: transparent; } }
.pz-row.is-guided { border-radius: 10px; outline: 2px solid var(--pz-accent, #5145cd); outline-offset: 3px; }
@media (prefers-reduced-motion: reduce) {
  .pz-guide *, .pz-guide-spot { animation: none !important; transition: none !important; }
}
@media (forced-colors: active) { .pz-guide-spot { outline-color: Highlight; } }
@media print { .pz-guide, .pz-guide-spot { display: none !important; } .pz-row.is-guided { outline: none; } }
`;
